import React from "react";
import "./loader.css";
import Logo from "./images/logoCarga";
//import loadingImage from "./images/Logo.png"; // Reemplaza con tu imagen

const Loader = () => {
    //console.log("pantalla de carga")
  return (
    <div className="loader-container">
        {/*<img src={loadingImage} alt="Loading..." className="loader" />*/}
        <Logo/>
    </div>
    );
};

export default Loader;